import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import "../certificate/cetification.css";

const AdminLogin = () => {
  const navigate = useNavigate();

  const { handleSubmit, handleChange, values, errors, handleBlur, touched } =
    useFormik({
      initialValues: {
        email: "",
        password: "",
      },
      onSubmit: async (values, { setSubmitting }) => {
        setRequestLogin(true);
        handleSubmits(values);
        setSubmitting(false);
      },
    });
  const [passwordType, setPasswordType] = useState("password");
  const [requestLogin, setRequestLogin] = useState(false);

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  const handleSubmits = async (e, login) => {
    var userData = {
      password: values.password,
      email: values.email,
    };
    if (userData.password === "Admin" && userData.email === "Admin") {
      navigate("/allUsersData");
    }
  };

  return (
    <section className="contact contact_us_md  app-section" data-theme="dark">
      <div className="container">
        <div
          className="row"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="col-lg-10"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="page-form">
              <div className="contact-flex">
                <div className="contact__text contact__title">
                  <h3 className="title" style={{ color: "#37cc3a" }}>
                    Login to your account
                  </h3>
                </div>
                <form
                  className="proForm row needs-validation m-0"
                  onSubmit={handleSubmit}
                >
                  <div className="col-lg-12">
                    <div className="linebylineInput has-validation">
                      {errors.email && touched.email && (
                        <span className="TextError required control-label">
                          {errors.email}
                        </span>
                      )}
                      <label
                        className="control-label"
                        htmlFor="email"
                        style={{ color: "white" }}
                      >
                        Email address*{" "}
                      </label>
                      <div className="inputDev ui input">
                        <input
                          type="text"
                          className="form-control large "
                          id="email"
                          name="email"
                          required
                          value={values.email}
                          onBlur={handleBlur}
                          placeholder="example@acme.inc"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="linebylineInput has-validation">
                      <label
                        className="control-label"
                        htmlFor="password"
                        style={{ color: "white" }}
                      >
                        password*
                      </label>
                      <span
                        onClick={togglePassword}
                        className="required control-label show_password"
                      >
                        {passwordType === "password" ? (
                          <span className="Show">
                            <svg
                              width="16px"
                              height="16px"
                              viewBox="0 0 16 16"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                            >
                              <title>
                                D52B25E1-54A5-40A5-BF2B-A81F428688D9
                              </title>
                              <desc>Created with sketchtool.</desc>
                              <defs />
                              <g
                                id="Symbols"
                                stroke="none"
                                strokeWidth={1}
                                fill="none"
                                fillRule="evenodd"
                              >
                                <g
                                  id="Action-icons/password/Show/16px/Light-grey_base"
                                  fill="#BCC4D1"
                                >
                                  <path
                                    d="M8,6.4064 C8.28758314,6.4064 8.55773294,6.47893261 8.81045752,6.624 C9.06318209,6.76906739 9.26361582,6.9653321 9.41176471,7.2128 C9.55991359,7.4602679 9.63398693,7.72479859 9.63398693,8.0064 C9.63398693,8.28800141 9.55991359,8.5525321 9.41176471,8.8 C9.26361582,9.0474679 9.06318209,9.24373261 8.81045752,9.3888 C8.55773294,9.53386739 8.28758314,9.6064 8,9.6064 C7.71241686,9.6064 7.44226706,9.53386739 7.18954248,9.3888 C6.93681791,9.24373261 6.73638418,9.0474679 6.58823529,8.8 C6.44008641,8.5525321 6.36601307,8.28800141 6.36601307,8.0064 C6.36601307,7.72479859 6.44008641,7.4602679 6.58823529,7.2128 C6.73638418,6.9653321 6.93681791,6.76906739 7.18954248,6.624 C7.44226706,6.47893261 7.71241686,6.4064 8,6.4064 Z M8,10.6816 C8.49673451,10.6816 8.95424627,10.5621345 9.37254902,10.3232 C9.79085176,10.0842655 10.1220031,9.76000205 10.3660131,9.3504 C10.610023,8.94079795 10.7320261,8.49280243 10.7320261,8.0064 C10.7320261,7.51999757 10.610023,7.07200205 10.3660131,6.6624 C10.1220031,6.25279795 9.79085176,5.92853453 9.37254902,5.6896 C8.95424627,5.45066547 8.49673451,5.3312 8,5.3312 C7.50326549,5.3312 7.04575373,5.45066547 6.62745098,5.6896 C6.20914824,5.92853453 5.87799686,6.25279795 5.63398693,6.6624 C5.38997699,7.07200205 5.26797386,7.51999757 5.26797386,8.0064 C5.26797386,8.49280243 5.38997699,8.94079795 5.63398693,9.3504 C5.87799686,9.76000205 6.20914824,10.0842655 6.62745098,10.3232 C7.04575373,10.5621345 7.50326549,10.6816 8,10.6816 Z M8,4 C8.89760797,4 9.75162993,4.17066496 10.5620915,4.512 C11.3464092,4.84480166 12.0370341,5.3141303 12.6339869,5.92 C13.2309398,6.5258697 13.6862729,7.22132941 14,8.0064 C13.6862729,8.79147059 13.2309398,9.48479699 12.6339869,10.0864 C12.0370341,10.688003 11.3464092,11.1551983 10.5620915,11.488 C9.75162993,11.829335 8.89760797,12 8,12 C7.10239203,12 6.24837007,11.829335 5.4379085,11.488 C4.65359085,11.1551983 3.96296595,10.688003 3.36601307,10.0864 C2.7690602,9.48479699 2.31372706,8.79147059 2,8.0064 C2.31372706,7.22132941 2.7690602,6.5258697 3.36601307,5.92 C3.96296595,5.3141303 4.65359085,4.84480166 5.4379085,4.512 C6.24837007,4.17066496 7.10239203,4 8,4 Z"
                                    id="visibility---material"
                                  />
                                </g>
                              </g>
                            </svg>{" "}
                            Show
                          </span>
                        ) : (
                          <span className="Hide">
                            <svg
                              width={15}
                              height={13}
                              viewBox="0 0 15 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M7 4.4064C7.28758 4.4064 7.55773 4.47893 7.81046 4.624C8.06318 4.76907 8.26362 4.96533 8.41177 5.2128C8.55991 5.46027 8.63399 5.7248 8.63399 6.0064C8.63399 6.288 8.55991 6.55253 8.41177 6.8C8.26362 7.04747 8.06318 7.24373 7.81046 7.3888C7.55773 7.53387 7.28758 7.6064 7 7.6064C6.71242 7.6064 6.44227 7.53387 6.18954 7.3888C5.93682 7.24373 5.73638 7.04747 5.58824 6.8C5.44009 6.55253 5.36601 6.288 5.36601 6.0064C5.36601 5.7248 5.44009 5.46027 5.58824 5.2128C5.73638 4.96533 5.93682 4.76907 6.18954 4.624C6.44227 4.47893 6.71242 4.4064 7 4.4064ZM7 8.6816C7.49673 8.6816 7.95425 8.56213 8.37255 8.3232C8.79085 8.08427 9.122 7.76 9.36601 7.3504C9.61002 6.9408 9.73203 6.4928 9.73203 6.0064C9.73203 5.52 9.61002 5.072 9.36601 4.6624C9.122 4.2528 8.79085 3.92853 8.37255 3.6896C7.95425 3.45067 7.49673 3.3312 7 3.3312C6.50327 3.3312 6.04575 3.45067 5.62745 3.6896C5.20915 3.92853 4.878 4.2528 4.63399 4.6624C4.38998 5.072 4.26797 5.52 4.26797 6.0064C4.26797 6.4928 4.38998 6.9408 4.63399 7.3504C4.878 7.76 5.20915 8.08427 5.62745 8.3232C6.04575 8.56213 6.50327 8.6816 7 8.6816ZM7 2C7.89761 2 8.75163 2.17067 9.56209 2.512C10.3464 2.8448 11.037 3.31413 11.634 3.92C12.2309 4.52587 12.6863 5.22133 13 6.0064C12.6863 6.79147 12.2309 7.4848 11.634 8.0864C11.037 8.688 10.3464 9.1552 9.56209 9.488C8.75163 9.82933 7.89761 10 7 10C6.10239 10 5.24837 9.82933 4.43791 9.488C3.65359 9.1552 2.96297 8.688 2.36601 8.0864C1.76906 7.4848 1.31373 6.79147 1 6.0064C1.31373 5.22133 1.76906 4.52587 2.36601 3.92C2.96297 3.31413 3.65359 2.8448 4.43791 2.512C5.24837 2.17067 6.10239 2 7 2Z"
                                fill="#BCC4D1"
                              />
                              <line
                                x1="13.9299"
                                y1="0.377845"
                                x2="0.327479"
                                y2="12.1666"
                                stroke="#BCC4D1"
                              />
                            </svg>
                            Hide
                          </span>
                        )}
                      </span>
                      <div className="inputDev ui input">
                        <input
                          type={passwordType}
                          className={
                            "form-control large " +
                            (errors.password && touched.password
                              ? " input_error"
                              : " ")
                          }
                          id="password"
                          name="password"
                          required
                          value={values.password}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.password && touched.password && (
                        <ul className="passValdiation password">
                          <li>
                            {
                              <img
                                src={`assets/images/icons/valdiationErr.svg`}
                                className="icon"
                                alt=""
                              />
                            }
                            {errors.password}
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>

                  {requestLogin === false ? (
                    <div className="col-12">
                      <div className="submitBtn">
                        <button
                          type="submit"
                          value="Submit"
                          className={
                            "primaryBtn-1 largeBtn btn " +
                            (!values.email ||
                            !values.password ||
                            errors.email ||
                            errors.password
                              ? "disabled"
                              : "")
                          }
                          disabled={
                            !values.email ||
                            !values.password ||
                            errors.email ||
                            errors.password
                          }
                        >
                          Login
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="col-12">
                      <div className="submitBtn">
                        <button className={"primaryBtn-1 largeBtn btn "}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 100 100"
                            preserveAspectRatio="xMidYMid"
                            className="lds-ellipsis"
                            style={{ background: "none" }}
                          >
                            <circle cx={84} cy={50} r={0} fill="#fff">
                              <animate
                                attributeName="r"
                                values="10;0;0;0;0"
                                keyTimes="0;0.25;0.5;0.75;1"
                                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                                calcMode="spline"
                                dur="1.7s"
                                repeatCount="indefinite"
                                begin="0s"
                              />
                              <animate
                                attributeName="cx"
                                values="84;84;84;84;84"
                                keyTimes="0;0.25;0.5;0.75;1"
                                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                                calcMode="spline"
                                dur="1.7s"
                                repeatCount="indefinite"
                                begin="0s"
                              />
                            </circle>
                            <circle cx={84} cy={50} r="3.53777" fill="#fff">
                              <animate
                                attributeName="r"
                                values="0;10;10;10;0"
                                keyTimes="0;0.25;0.5;0.75;1"
                                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                                calcMode="spline"
                                dur="1.7s"
                                repeatCount="indefinite"
                                begin="-0.85s"
                              />
                              <animate
                                attributeName="cx"
                                values="16;16;50;84;84"
                                keyTimes="0;0.25;0.5;0.75;1"
                                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                                calcMode="spline"
                                dur="1.7s"
                                repeatCount="indefinite"
                                begin="-0.85s"
                              />
                            </circle>
                            <circle cx="71.9716" cy={50} r={10} fill="#fff">
                              <animate
                                attributeName="r"
                                values="0;10;10;10;0"
                                keyTimes="0;0.25;0.5;0.75;1"
                                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                                calcMode="spline"
                                dur="1.7s"
                                repeatCount="indefinite"
                                begin="-0.425s"
                              />
                              <animate
                                attributeName="cx"
                                values="16;16;50;84;84"
                                keyTimes="0;0.25;0.5;0.75;1"
                                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                                calcMode="spline"
                                dur="1.7s"
                                repeatCount="indefinite"
                                begin="-0.425s"
                              />
                            </circle>
                            <circle cx="37.9716" cy={50} r={10} fill="#fff">
                              <animate
                                attributeName="r"
                                values="0;10;10;10;0"
                                keyTimes="0;0.25;0.5;0.75;1"
                                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                                calcMode="spline"
                                dur="1.7s"
                                repeatCount="indefinite"
                                begin="0s"
                              />
                              <animate
                                attributeName="cx"
                                values="16;16;50;84;84"
                                keyTimes="0;0.25;0.5;0.75;1"
                                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                                calcMode="spline"
                                dur="1.7s"
                                repeatCount="indefinite"
                                begin="0s"
                              />
                            </circle>
                            <circle cx={16} cy={50} r="6.46224" fill="#fff">
                              <animate
                                attributeName="r"
                                values="0;0;10;10;10"
                                keyTimes="0;0.25;0.5;0.75;1"
                                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                                calcMode="spline"
                                dur="1.7s"
                                repeatCount="indefinite"
                                begin="0s"
                              />
                              <animate
                                attributeName="cx"
                                values="16;16;16;50;84"
                                keyTimes="0;0.25;0.5;0.75;1"
                                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                                calcMode="spline"
                                dur="1.7s"
                                repeatCount="indefinite"
                                begin="0s"
                              />
                            </circle>
                          </svg>
                        </button>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminLogin;
